<template>
  <div class="content">
    <div class="header">
      <van-nav-bar title="全部评价" @click-left="toback" left-text left-arrow />
    </div>
    <div class="appraisal">
      <div class="appraisalHeader">
        <h3>用户评价({{ commentLength }})</h3>
        <span
          class="lookAll"
          @click="$router.replace('/evaluationDetails')"
        ></span>
      </div>
      <!-- <div v-if="Evaluation" class="appraisalFilter">
        <van-button plain size="small" type="primary"
          >质量不错 (528)</van-button
        >
        <van-button plain size="small" type="primary">很划算 (528)</van-button
        ><van-button plain size="small" type="primary">视频 (528)</van-button
        ><van-button plain size="small" type="primary"
          >发货很快 (528)</van-button
        >
      </div> -->
    </div>
    <div v-if="Evaluation" class="appraisalList">
      <ul>
        <li v-for="item in commentList" :key="item.id">
          <div class="head">
            <img :src="item.user_head_img" alt="" />
            <div class="headTop">
              <span class="name">{{ item.user_name }}</span>
              <div class="headeValuate">
                <p>{{ item.add_time }}</p>
                <van-rate
                  size=" 0.346667rem"
                  color="#FC563A"
                  readonly
                  v-model="item.log_score"
                />
              </div>
            </div>
          </div>
          <p class="evaluateConent">{{ item.remark }}</p>
          <!-- 图片 -->
          <div class="cpnentImg">
            <img
              v-for="(element, index) in item.url_list"
              :key="element.id"
              :src="element.fileUrl"
              @click.stop="showImagePreview(item, index)"
              alt=""
            />
          </div>
        </li>
      </ul>
    </div>
    <van-image-preview v-model="ImagePreviewShow" :images="imagesLists">
    </van-image-preview>
  </div>
</template>
<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      bigImg: sessionStorage.getItem("P_IMG"),
      activeName: 2,
      commentList: {},
      commentLength: "",
      Evaluation: true,
      imagesLists: [],
      ImagePreviewShow: false,
      imgIndex: 0,
      list: [],
    };
  },
  created() {
    this.getComment();
  },
  methods: {
    toback() {
      this.$router.go(-1);
    },
    // 获取评论
    async getComment() {
      await this.$post({
        url: "ogc/getByGoodssn",
        method: "get",
        params: {
          goods_sn: sessionStorage.getItem("P_ID"),
          // content: Math.round(Math.random() * 100),
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.commentList = res.data;
            this.commentLength = res.data.length;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showImagePreview(item, index) {
      this.carouselImg = [];
      item.url_list.forEach((element) => {
        this.carouselImg.push(element.fileUrl);
      });
      // 图片下标
      this.pageIndex = index;
      ImagePreview({
        images: this.carouselImg,
        // 关闭按钮
        closeable: true,
        // 开启循环播放
        loop: false,
        // 显示页码
        showIndex: true,
        // 图片预览起始索引
        startPosition: this.pageIndex,
      });
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  background-color: #ffffff;
  .header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #ffffff;
    .van-nav-bar {
      background-color: transparent !important;
      .van-nav-bar__title.van-ellipsis {
        font-size: 0.48rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }
      /deep/.van-nav-bar__left {
        .van-icon {
          color: #333333 !important;
          font-size: 0.533333rem;
        }
      }
      /deep/.van-nav-bar__title.van-ellipsis {
        font-weight: 600 !important;
      }
    }
    .van-hairline--bottom::after {
      border-bottom-width: 0;
    }
  }
  .details {
    margin-top: 1.5rem;
  }
  .appraisal {
    margin-top: 1.5rem;
    background-color: #fff;
    padding: 0.35rem 0.37rem;
    .appraisalHeader {
      margin-bottom: 0.4rem;
      overflow: hidden;
      h3 {
        float: left;
        font-size: 0.37rem;
        margin-top: 0.1rem;
      }
      .lookAll {
        float: right;
        font-size: 0.36rem;
        color: #333333;
      }
    }
    // 评价按钮
    .appraisalFilter {
      padding-bottom: 0.3rem;
      border-bottom: 0.026667rem solid #eeeeee;
      .van-button {
        margin: 0.1125rem 0;
        margin-right: 0.32rem;
        border-radius: 15px;
        height: 0.64rem;
        line-height: 0.64rem;
        text-align: center;
        color: #333333;
        border-color: #e0e0e0;
        background-color: #e0e0e0;
      }
    }
  }
  .appraisalList {
    background-color: #fff;
    margin-bottom: 0.5rem;
    ul {
      li {
        margin: 0 0.4rem 0 0.426667rem;
        border-bottom: 1px solid #eeeeee;
        // overflow: hidden;
        .head {
          // margin-top: 0.213333rem;
          padding-top: 0.213333rem;
          display: flex;
          img {
            width: 0.906667rem;
            height: 0.906667rem;
            border-radius: 50%;
            border: 1px solid #ededed;
          }
          .headTop {
            margin-left: 0.373333rem;
            .name {
              font-size: 0.373333rem;
              font-weight: 400;
              color: #333333;
              font-family: PingFang SC;
            }
            .headeValuate {
              display: flex;
              align-items: center;
              p {
                margin-top: 0.08rem;
                width: 2rem;
                height: 0.373333rem;
                overflow: hidden;
                font-size: 0.32rem;
                font-weight: 400;
                color: #666666;
              }
            }
          }
        }
        .evaluateConent {
          margin: 0.45rem 0;
          font-size: 0.32rem;
          font-weight: 400;
          color: #333333;
        }
        .cpnentImg {
          display: flex;
          flex-wrap: wrap;
          justify-content: last baseline;
          // justify-content: start;
          img {
            width: 2.133333rem;
            height: 2.133333rem;
            margin: 0 0.16rem 0.213333rem 0;
            border-radius: 0.053333rem;
          }
        }
      }
    }
  }
}
</style>
